export class DataSourceServiceConfig {
    public static EndPoint = {
        Setting: {
          getOrganizationDbs:'/database/dataSource/getOrganizationDbs',
          updateData:'/database/DataSource/addOrUpdate',
          getList:'/database/getSchemasByDB/{dbaliasname}',
          schemaCheck:'/database/organization/{organizationid}/{dbaliasname}',
          updateSchema:'/database/addOrganizationSchemaByDB  '
        }
      };
}
